(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sdd-associate-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeAssociateForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';

      root.dataset.ready = 'true';

      const removeOldForm = () => {
        const oldForm = productForm.querySelector('#infiniteoptions-container');
        if (oldForm) oldForm.remove();
      };

      removeOldForm();
      new MutationObserver(removeOldForm).observe(productForm, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'AssociateProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => {
        control.setAttribute('form', productFormId);
      });

      const progress = root.querySelector('.sdd-native-form__progress');
      const ready = root.querySelector('.sdd-native-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const sizeSelect = root.querySelector('[data-size-select]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const folderSection = root.querySelector('[data-folder-section]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };

      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);

      const priceFromText = (value) => {
        const match = String(value || '').match(/\+\s*\$([\d,]+(?:\.\d{1,2})?)/);
        return match ? Math.round(Number(match[1].replace(/,/g, '')) * 100) : 0;
      };

      const cleanCostLabel = (value) => String(value || '')
        .replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '')
        .trim();

      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };

      const addCostRow = (label, cents) => {
        addReviewRow(reviewCosts, label, formatMoney(cents));
      };

      const calculateTotal = () => {
        const variant = currentVariant();
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          total += priceFromText(delivery.closest('label')?.textContent || delivery.value);
        }

        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]').forEach((select) => {
            const option = select.selectedOptions[0];
            if (option?.dataset.addon) total += priceFromText(option.textContent);
          });

          if (folderSelect && !folderSelect.disabled && folderSelect.value !== 'None') {
            const option = folderSelect.selectedOptions[0];
            total += option?.dataset.folder === 'graduation'
              ? Number(folderColor?.selectedOptions[0]?.dataset.gradPrice || 0)
              : priceFromText(option?.textContent);
          }
        }

        return total;
      };

      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };

      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();

        const variant = currentVariant();
        if (variant?.title && variant.title !== 'Default Title') {
          addReviewRow(reviewSelections, root.dataset.labelProductOption, variant.title);
        }

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;

          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;

          const value = control.tagName === 'SELECT'
            ? control.selectedOptions[0]?.textContent.trim()
            : String(control.value || '').trim();
          if (!value) return;

          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;
        addCostRow(root.dataset.productTitle, total);

        const paidItems = [];
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          const text = delivery.closest('label')?.textContent || delivery.value;
          paidItems.push({ label: cleanCostLabel(delivery.value), cents: priceFromText(text) });
        }

        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            paidItems.push({
              label: cleanCostLabel(option.textContent),
              cents: priceFromText(option.textContent)
            });
          });

          if (folderSelect && !folderSelect.disabled && folderSelect.value !== 'None') {
            const option = folderSelect.selectedOptions[0];
            const isGraduationFolder = option?.dataset.folder === 'graduation';
            const cents = isGraduationFolder
              ? Number(folderColor?.selectedOptions[0]?.dataset.gradPrice || 0)
              : priceFromText(option?.textContent);
            const color = isGraduationFolder ? folderColor?.selectedOptions[0]?.textContent.trim() : '';
            const label = color
              ? cleanCostLabel(option?.textContent) + ' — ' + color
              : cleanCostLabel(option?.textContent);
            paidItems.push({ label, cents });
          }
        }

        paidItems.forEach((item) => {
          if (!item.cents) return;
          total += item.cents;
          addCostRow(item.label, item.cents);
        });

        reviewTotal.textContent = formatMoney(total);
      };

      const setFieldState = (wrapper, shown, required) => {
        if (!wrapper) return;
        wrapper.hidden = !shown;
        wrapper.querySelectorAll('input, textarea, select').forEach((control) => {
          control.disabled = !shown;
          control.required = Boolean(required && shown);
        });
      };

      const selectedDelivery = () => root.querySelector('input[name="properties[Delivery Option]"]:checked');
      const isPrinted = () => Boolean(selectedDelivery()?.dataset.addon);

      const updateFolderFields = () => {
        const folderValue = folderSelect?.value || 'None';
        const hasFolder = !folderSelect?.disabled && folderValue !== 'None';
        setFieldState(folderColorField, hasFolder, hasFolder);
        setFieldState(
          folderCustomField,
          hasFolder && folderSelect?.selectedOptions[0]?.dataset.folder === 'custom',
          hasFolder && folderSelect?.selectedOptions[0]?.dataset.folder === 'custom'
        );
      };

      const updateConditionalFields = () => {
        const printed = isPrinted();
        if (printUpgrades) {
          printUpgrades.hidden = !printed;
          printUpgrades.querySelectorAll('input, textarea, select').forEach((control) => {
            control.disabled = !printed;
          });
        }

        const customSize = sizeSelect?.value === 'Custom sized diploma';
        setFieldState(customSizeField, customSize, customSize);

        if (folderSection) {
          const showFolder = printed && !customSize;
          folderSection.hidden = !showFolder;
          folderSelect.disabled = !showFolder;
          if (!showFolder) folderSelect.value = 'None';
        }

        updateFolderFields();
      };

      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (nextStep) => {
        step = Math.max(1, Math.min(nextStep, 3));
        root.querySelectorAll('[data-step]').forEach((section) => {
          section.hidden = Number(section.dataset.step) !== step;
        });
        root.querySelectorAll('.sdd-native-form__progress span').forEach((item, index) => {
          item.classList.toggle('is-active', index < step);
          if (index === step - 1) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
        });
      };

      const validateCurrentStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const fields = Array.from(section?.querySelectorAll('[required]') || []).filter((field) => !field.disabled);
        const invalid = fields.find((field) => !field.checkValidity());

        fields.forEach((field) => {
          field.setAttribute('aria-invalid', String(!field.checkValidity()));
        });

        if (!invalid) return true;
        invalid.reportValidity();
        invalid.focus({ preventScroll: true });
        invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      };

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateCurrentStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }

        if (event.target.closest('[data-finish]') && validateCurrentStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }

        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(3);
        }
      });

      root.querySelectorAll('input[name="properties[Delivery Option]"]').forEach((control) => {
        control.addEventListener('change', updateConditionalFields);
      });
      sizeSelect?.addEventListener('change', updateConditionalFields);
      folderSelect?.addEventListener('change', updateFolderFields);
      root.addEventListener('change', () => {
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        errorBox.hidden = true;
        errorBox.textContent = '';

        const invalid = Array.from(root.querySelectorAll('[required]')).find(
          (field) => !field.disabled && !field.checkValidity()
        );

        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = Number(invalid.closest('[data-step]')?.dataset.step || 1);
          ready.hidden = true;
          progress.hidden = false;
          show(invalidStep);
          invalid.reportValidity();
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';

        const properties = {};
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          if (!control.value) return;
          properties[control.name.slice(11, -1)] = control.value;
        });

        const orderGroup = 'SDD-' + Date.now();
        properties['_SDD Order Group'] = orderGroup;

        const addonItems = [];
        const addAddon = (variantId, quantity) => {
          const numericId = Number(String(variantId || '').replace(/\D/g, ''));
          const itemQuantity = Number(quantity || 1);
          if (!numericId || itemQuantity < 1) return;
          addonItems.push({
            id: numericId,
            quantity: itemQuantity,
            properties: {
              '_SDD Order Group': orderGroup,
              'For': (properties["Graduate's Name"] || '') + ' — ' + (properties['School or University'] || '')
            }
          });
        };

        addAddon(selectedDelivery()?.dataset.addon, 1);

        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]').forEach((select) => {
            const option = select.selectedOptions[0];
            addAddon(option?.dataset.addon, option?.dataset.quantity);
          });

          if (folderSelect && !folderSelect.disabled && folderSelect.value !== 'None') {
            const folderOption = folderSelect.selectedOptions[0];
            const folderId = folderOption?.dataset.folder === 'graduation'
              ? folderColor?.selectedOptions[0]?.dataset.gradAddon
              : folderOption?.dataset.addon;
            addAddon(folderId, 1);
          }
        }

        const variantId = Number(productForm.querySelector('[name="id"]').value);
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const items = [
          { id: variantId, quantity, properties },
          ...addonItems
        ];

        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            const responseBody = await response.json().catch(() => ({}));
            throw new Error(responseBody.description || root.dataset.errorAdd);
          }

          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          errorBox.textContent = error?.message || root.dataset.errorAdd;
          errorBox.hidden = false;
          if (submit) submit.disabled = false;
        }
      }, true);

      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-sdd-native-form]').forEach(initializeAssociateForm);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll);
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-canada-secondary-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return false;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      };
      const syncDeliveryFromCurrentVariant = () => {
        if (!hasNativeDelivery) return;
        const delivery = String(currentVariant()?.option1 || currentVariant()?.options?.[0] || '');
        const input = [...root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]')]
          .find((candidate) => String(candidate.dataset.optionValue || '') === delivery);
        if (input) input.checked = true;
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && (!syncNativeState() || !syncNativeVariant())) {
          if (nativeStateError) nativeStateError.hidden = false;
          errorBox.textContent = 'Please choose a valid delivery option.';
          errorBox.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState() || !syncNativeVariant()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          errorBox.textContent = 'Please choose a valid delivery option.';
          errorBox.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      syncDeliveryFromCurrentVariant();
      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-abe-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-achievement-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-bartending-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-cambridge-esol-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-cieh-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-culinary-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-fetac-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-global-all-kinds-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-goalkeeping-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-match-scan-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-property-manager-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-scottish-qa-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-six-sigma-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-tafe-bundle-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-tafe-iii-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-tafe-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-tesol-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-trainer-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-certificate-usa-all-kinds-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'certificate' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const productOptionChoice = root.querySelector('[data-product-option-choice]');
      const productOptionProperty = root.querySelector('[data-product-option-property]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const syncProductOption = () => {
        if (!productOptionChoice) return;
        const option = productOptionChoice.selectedOptions[0];
        const idInput = productForm.querySelector('[name="id"]');
        if (!option?.dataset.variantId || !idInput) return;
        if (String(idInput.value) !== String(option.dataset.variantId)) {
          idInput.value = String(option.dataset.variantId);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (productOptionProperty) productOptionProperty.value = option.textContent.trim();
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncProductOption();
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice], [data-product-option-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'Certificate order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncProductOption();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-college-match-bundle-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'college' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const referenceFile = root.querySelector('[data-native-reference-file]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);
      const validateReferenceFile = () => {
        if (!referenceFile) return true;
        const file = referenceFile.files?.[0];
        let message = '';
        if (file && !/\.(pdf|jpe?g|png|heic|heif)$/i.test(file.name)) {
          message = 'Please upload a PDF, JPG, JPEG, PNG, HEIC or HEIF file.';
        } else if (file && file.size > 20 * 1024 * 1024) {
          message = 'Please choose a file that is 20 MB or smaller.';
        }
        referenceFile.setCustomValidity(message);
        return !message;
      };

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        validateReferenceFile();
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        if (referenceFile?.files?.[0]) addReviewRow(reviewSelections, 'Example / Reference File', referenceFile.files[0].name);

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-native-reference-file]')) validateReferenceFile();
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        validateReferenceFile();
        const invalid = [...root.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        const hasReferenceFile = Boolean(referenceFile?.files?.length);
        if (!addons.length && !hasReferenceFile) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        formData.delete('sdd_college_delivery');
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (value instanceof File) continue;
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const addonItems = addons.map((entry) => ({
          id: entry.id,
          quantity: entry.quantity,
          properties: addonProperties
        }));

        try {
          if (hasReferenceFile) {
            const mainResponse = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData
            });
            if (!mainResponse.ok) throw new Error('Main product upload failed');
            const mainLine = await mainResponse.json();

            if (addonItems.length) {
              const addonResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: addonItems })
              });
              if (!addonResponse.ok) {
                if (mainLine?.key) {
                  await fetch(root.dataset.cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: mainLine.key, quantity: 0 })
                  }).catch(() => {});
                }
                throw new Error('Add-on request failed');
              }
            }
          } else {
            const items = [
              { id: variantId, quantity, properties },
              ...addonItems
            ];
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-college-match-diploma-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'college' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const referenceFile = root.querySelector('[data-native-reference-file]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);
      const validateReferenceFile = () => {
        if (!referenceFile) return true;
        const file = referenceFile.files?.[0];
        let message = '';
        if (file && !/\.(pdf|jpe?g|png|heic|heif)$/i.test(file.name)) {
          message = 'Please upload a PDF, JPG, JPEG, PNG, HEIC or HEIF file.';
        } else if (file && file.size > 20 * 1024 * 1024) {
          message = 'Please choose a file that is 20 MB or smaller.';
        }
        referenceFile.setCustomValidity(message);
        return !message;
      };

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        validateReferenceFile();
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        if (referenceFile?.files?.[0]) addReviewRow(reviewSelections, 'Example / Reference File', referenceFile.files[0].name);

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-native-reference-file]')) validateReferenceFile();
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        validateReferenceFile();
        const invalid = [...root.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        syncDeliveryProperty();
        const addons = selectedAddonEntries();
        const hasReferenceFile = Boolean(referenceFile?.files?.length);
        const deliveryInput = selectedDelivery();
        const deliveryKind = String(deliveryInput?.dataset.deliveryKind || 'digital');
        const needsShippingLine = deliveryKind === 'printed' || deliveryKind === 'both';

        if (needsShippingLine) {
          const shippingAddonId = deliveryInput?.dataset?.addon;
          if (!shippingAddonId) {
            event.preventDefault();
            event.stopImmediatePropagation();
            errorBox.textContent = 'Printed delivery is not available right now. Please choose digital delivery or contact us for help.';
            errorBox.hidden = false;
            return;
          }
          if (!addons.some((entry) => String(entry.id) === String(shippingAddonId))) {
            addons.push({
              id: Number(shippingAddonId),
              quantity: 1,
              price: optionPrice(deliveryInput),
              label: cleanLabel(deliveryInput.value)
            });
          }
        }

        if (!usesFormDelivery && !addons.length && !hasReferenceFile) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        formData.delete('sdd_college_delivery');
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (value instanceof File) continue;
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const addonItems = addons.map((entry) => ({
          id: entry.id,
          quantity: entry.quantity,
          properties: addonProperties
        }));

        try {
          if (hasReferenceFile) {
            const mainResponse = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData
            });
            if (!mainResponse.ok) throw new Error('Main product upload failed');
            const mainLine = await mainResponse.json();

            if (addonItems.length) {
              const addonResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: addonItems })
              });
              if (!addonResponse.ok) {
                if (mainLine?.key) {
                  await fetch(root.dataset.cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: mainLine.key, quantity: 0 })
                  }).catch(() => {});
                }
                throw new Error('Add-on request failed');
              }
            }
          } else {
            const items = [
              { id: variantId, quantity, properties },
              ...addonItems
            ];
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-college-match-diploma-stock-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'college' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const referenceFile = root.querySelector('[data-native-reference-file]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);
      const validateReferenceFile = () => {
        if (!referenceFile) return true;
        const file = referenceFile.files?.[0];
        let message = '';
        if (file && !/\.(pdf|jpe?g|png|heic|heif)$/i.test(file.name)) {
          message = 'Please upload a PDF, JPG, JPEG, PNG, HEIC or HEIF file.';
        } else if (file && file.size > 20 * 1024 * 1024) {
          message = 'Please choose a file that is 20 MB or smaller.';
        }
        referenceFile.setCustomValidity(message);
        return !message;
      };

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        validateReferenceFile();
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        if (referenceFile?.files?.[0]) addReviewRow(reviewSelections, 'Example / Reference File', referenceFile.files[0].name);

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-native-reference-file]')) validateReferenceFile();
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        validateReferenceFile();
        const invalid = [...root.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        const hasReferenceFile = Boolean(referenceFile?.files?.length);
        if (!addons.length && !hasReferenceFile) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        formData.delete('sdd_college_delivery');
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (value instanceof File) continue;
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const addonItems = addons.map((entry) => ({
          id: entry.id,
          quantity: entry.quantity,
          properties: addonProperties
        }));

        try {
          if (hasReferenceFile) {
            const mainResponse = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData
            });
            if (!mainResponse.ok) throw new Error('Main product upload failed');
            const mainLine = await mainResponse.json();

            if (addonItems.length) {
              const addonResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: addonItems })
              });
              if (!addonResponse.ok) {
                if (mainLine?.key) {
                  await fetch(root.dataset.cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: mainLine.key, quantity: 0 })
                  }).catch(() => {});
                }
                throw new Error('Add-on request failed');
              }
            }
          } else {
            const items = [
              { id: variantId, quantity, properties },
              ...addonItems
            ];
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-college-match-scan-bundle-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'college' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const referenceFile = root.querySelector('[data-native-reference-file]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);
      const validateReferenceFile = () => {
        if (!referenceFile) return true;
        const file = referenceFile.files?.[0];
        let message = '';
        if (file && !/\.(pdf|jpe?g|png|heic|heif)$/i.test(file.name)) {
          message = 'Please upload a PDF, JPG, JPEG, PNG, HEIC or HEIF file.';
        } else if (file && file.size > 20 * 1024 * 1024) {
          message = 'Please choose a file that is 20 MB or smaller.';
        }
        referenceFile.setCustomValidity(message);
        return !message;
      };

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        validateReferenceFile();
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        if (referenceFile?.files?.[0]) addReviewRow(reviewSelections, 'Example / Reference File', referenceFile.files[0].name);

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-native-reference-file]')) validateReferenceFile();
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        validateReferenceFile();
        const invalid = [...root.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        const hasReferenceFile = Boolean(referenceFile?.files?.length);
        if (!addons.length && !hasReferenceFile) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        formData.delete('sdd_college_delivery');
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (value instanceof File) continue;
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const addonItems = addons.map((entry) => ({
          id: entry.id,
          quantity: entry.quantity,
          properties: addonProperties
        }));

        try {
          if (hasReferenceFile) {
            const mainResponse = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData
            });
            if (!mainResponse.ok) throw new Error('Main product upload failed');
            const mainLine = await mainResponse.json();

            if (addonItems.length) {
              const addonResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: addonItems })
              });
              if (!addonResponse.ok) {
                if (mainLine?.key) {
                  await fetch(root.dataset.cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: mainLine.key, quantity: 0 })
                  }).catch(() => {});
                }
                throw new Error('Add-on request failed');
              }
            }
          } else {
            const items = [
              { id: variantId, quantity, properties },
              ...addonItems
            ];
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-college-match-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'college' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const referenceFile = root.querySelector('[data-native-reference-file]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);
      const validateReferenceFile = () => {
        if (!referenceFile) return true;
        const file = referenceFile.files?.[0];
        let message = '';
        if (file && !/\.(pdf|jpe?g|png|heic|heif)$/i.test(file.name)) {
          message = 'Please upload a PDF, JPG, JPEG, PNG, HEIC or HEIF file.';
        } else if (file && file.size > 20 * 1024 * 1024) {
          message = 'Please choose a file that is 20 MB or smaller.';
        }
        referenceFile.setCustomValidity(message);
        return !message;
      };

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        validateReferenceFile();
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        if (referenceFile?.files?.[0]) addReviewRow(reviewSelections, 'Example / Reference File', referenceFile.files[0].name);

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-native-reference-file]')) validateReferenceFile();
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        validateReferenceFile();
        const invalid = [...root.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        const hasReferenceFile = Boolean(referenceFile?.files?.length);
        if (!addons.length && !hasReferenceFile) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        formData.delete('sdd_college_delivery');
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (value instanceof File) continue;
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const addonItems = addons.map((entry) => ({
          id: entry.id,
          quantity: entry.quantity,
          properties: addonProperties
        }));

        try {
          if (hasReferenceFile) {
            const mainResponse = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData
            });
            if (!mainResponse.ok) throw new Error('Main product upload failed');
            const mainLine = await mainResponse.json();

            if (addonItems.length) {
              const addonResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: addonItems })
              });
              if (!addonResponse.ok) {
                if (mainLine?.key) {
                  await fetch(root.dataset.cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: mainLine.key, quantity: 0 })
                  }).catch(() => {});
                }
                throw new Error('Add-on request failed');
              }
            }
          } else {
            const items = [
              { id: variantId, quantity, properties },
              ...addonItems
            ];
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-college-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'college' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const referenceFile = root.querySelector('[data-native-reference-file]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);
      const validateReferenceFile = () => {
        if (!referenceFile) return true;
        const file = referenceFile.files?.[0];
        let message = '';
        if (file && !/\.(pdf|jpe?g|png|heic|heif)$/i.test(file.name)) {
          message = 'Please upload a PDF, JPG, JPEG, PNG, HEIC or HEIF file.';
        } else if (file && file.size > 20 * 1024 * 1024) {
          message = 'Please choose a file that is 20 MB or smaller.';
        }
        referenceFile.setCustomValidity(message);
        return !message;
      };

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        validateReferenceFile();
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        if (referenceFile?.files?.[0]) addReviewRow(reviewSelections, 'Example / Reference File', referenceFile.files[0].name);

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-native-reference-file]')) validateReferenceFile();
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        validateReferenceFile();
        const invalid = [...root.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        syncDeliveryProperty();
        const addons = selectedAddonEntries();
        const hasReferenceFile = Boolean(referenceFile?.files?.length);
        const deliveryInput = selectedDelivery();
        const deliveryKind = String(deliveryInput?.dataset.deliveryKind || 'digital');
        const needsShippingLine = deliveryKind === 'printed' || deliveryKind === 'both';

        if (needsShippingLine) {
          const shippingAddonId = deliveryInput?.dataset?.addon;
          if (!shippingAddonId) {
            event.preventDefault();
            event.stopImmediatePropagation();
            errorBox.textContent = 'Printed delivery is not available right now. Please choose digital delivery or contact us for help.';
            errorBox.hidden = false;
            return;
          }
          if (!addons.some((entry) => String(entry.id) === String(shippingAddonId))) {
            addons.push({
              id: Number(shippingAddonId),
              quantity: 1,
              price: optionPrice(deliveryInput),
              label: cleanLabel(deliveryInput.value)
            });
          }
        }

        if (!usesFormDelivery && !addons.length && !hasReferenceFile) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        formData.delete('sdd_college_delivery');
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (value instanceof File) continue;
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const addonItems = addons.map((entry) => ({
          id: entry.id,
          quantity: entry.quantity,
          properties: addonProperties
        }));

        try {
          if (hasReferenceFile) {
            const mainResponse = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData
            });
            if (!mainResponse.ok) throw new Error('Main product upload failed');
            const mainLine = await mainResponse.json();

            if (addonItems.length) {
              const addonResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: addonItems })
              });
              if (!addonResponse.ok) {
                if (mainLine?.key) {
                  await fetch(root.dataset.cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: mainLine.key, quantity: 0 })
                  }).catch(() => {});
                }
                throw new Error('Add-on request failed');
              }
            }
          } else {
            const items = [
              { id: variantId, quantity, properties },
              ...addonItems
            ];
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-college-stock-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'college' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const referenceFile = root.querySelector('[data-native-reference-file]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);
      const validateReferenceFile = () => {
        if (!referenceFile) return true;
        const file = referenceFile.files?.[0];
        let message = '';
        if (file && !/\.(pdf|jpe?g|png|heic|heif)$/i.test(file.name)) {
          message = 'Please upload a PDF, JPG, JPEG, PNG, HEIC or HEIF file.';
        } else if (file && file.size > 20 * 1024 * 1024) {
          message = 'Please choose a file that is 20 MB or smaller.';
        }
        referenceFile.setCustomValidity(message);
        return !message;
      };

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        validateReferenceFile();
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        if (referenceFile?.files?.[0]) addReviewRow(reviewSelections, 'Example / Reference File', referenceFile.files[0].name);

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-native-reference-file]')) validateReferenceFile();
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        validateReferenceFile();
        const invalid = [...root.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        const hasReferenceFile = Boolean(referenceFile?.files?.length);
        if (!addons.length && !hasReferenceFile) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        formData.delete('sdd_college_delivery');
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (value instanceof File) continue;
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const addonItems = addons.map((entry) => ({
          id: entry.id,
          quantity: entry.quantity,
          properties: addonProperties
        }));

        try {
          if (hasReferenceFile) {
            const mainResponse = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData
            });
            if (!mainResponse.ok) throw new Error('Main product upload failed');
            const mainLine = await mainResponse.json();

            if (addonItems.length) {
              const addonResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: addonItems })
              });
              if (!addonResponse.ok) {
                if (mainLine?.key) {
                  await fetch(root.dataset.cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: mainLine.key, quantity: 0 })
                  }).catch(() => {});
                }
                throw new Error('Add-on request failed');
              }
            }
          } else {
            const items = [
              { id: variantId, quantity, properties },
              ...addonItems
            ];
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-cover-custom-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCoverForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CoverProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const variants = JSON.parse(root.querySelector('[data-cover-variant-map]')?.textContent || '[]');
      const isCustom = root.dataset.isCustom === 'true';
      const sizeChoice = root.querySelector('[data-cover-size]');
      const colorChoice = root.querySelector('[data-cover-color]');
      const customizationChoice = root.querySelector('[data-cover-customization]');
      const textField = root.querySelector('[data-cover-text-field]');
      const logoField = root.querySelector('[data-cover-logo-field]');
      const studentField = root.querySelector('[data-cover-student-field]');
      const progress = root.querySelector('.sdd-cover-form__progress');
      const ready = root.querySelector('.sdd-cover-form__ready');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const reviewSelectionLists = root.querySelectorAll('[data-review-selections]');
      const reviewCostLists = root.querySelectorAll('[data-review-costs]');
      const reviewTotals = root.querySelectorAll('[data-review-total]');
      let step = 1;

      const selectedVariant = () => variants.find((variant) => (
        String(variant.size || '') === String(sizeChoice?.value || '')
        && String(variant.color || '') === String(colorChoice?.value || '')
        && String(variant.customization || '') === String(customizationChoice?.value || '')
      )) || variants[0];

      const currentQuantity = () => Number(productForm.querySelector('[name="quantity"]')?.value || 1);
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);

      const syncVariant = () => {
        const match = selectedVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      const setFieldState = (field, active) => {
        if (!field) return;
        const input = field.querySelector('input, textarea, select');
        field.hidden = !active;
        if (!input) return;
        input.disabled = !active;
        input.required = active;
      };

      const updateConditionalFields = () => {
        const choice = String(customizationChoice?.value || '').toLowerCase();
        const needsStudent = choice.includes('student name');
        if (isCustom) {
          setFieldState(textField, choice.includes('text'));
          setFieldState(logoField, choice.includes('logo'));
          setFieldState(studentField, needsStudent);
        } else {
          setFieldState(studentField, needsStudent);
        }
      };

      const calculateTotal = () => Number(selectedVariant()?.price || 0) * currentQuantity();
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };

      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };

      const renderSelections = (list) => {
        list.replaceChildren();
        addReviewRow(list, 'Cover size', sizeChoice?.value || '');
        addReviewRow(list, 'Cover color', colorChoice?.value || '');
        addReviewRow(list, isCustom ? 'Customization' : 'Personalization', customizationChoice?.value || '');

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          let label = control.name.slice(11, -1).replace(/:$/, '').trim();
          const friendlyLabels = {
            'Folder option - standard': 'Standard folder option',
            'Text Customization Here If Applicable': 'Text customization',
            'Logo Customization Customization, If Applicable': 'Logo customization',
            'Student Name If Applicable': 'Student name'
          };
          label = friendlyLabels[label] || label;
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT'
            ? control.selectedOptions[0]?.textContent.trim()
            : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(list, label, value);
        });
      };

      const renderCosts = (list) => {
        list.replaceChildren();
        const quantity = currentQuantity();
        addReviewRow(
          list,
          root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''),
          formatMoney(calculateTotal())
        );
      };

      const renderReview = () => {
        reviewSelectionLists.forEach(renderSelections);
        reviewCostLists.forEach(renderCosts);
        reviewTotals.forEach((element) => { element.textContent = formatMoney(calculateTotal()); });
      };

      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => {
          section.hidden = Number(section.dataset.step) !== number;
        });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
        if (number === 3) renderReview();
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-cover-size], [data-cover-color], [data-cover-customization]')) {
          syncVariant();
          updateConditionalFields();
        }
        updateLiveTotal();
        if (!ready.hidden || step === 3) renderReview();
      });

      productForm.addEventListener('input', () => {
        updateLiveTotal();
        if (!ready.hidden || step === 3) renderReview();
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', (event) => {
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (!invalid) return;
        event.preventDefault();
        const invalidStep = invalid.closest('[data-step]');
        ready.hidden = true;
        progress.hidden = false;
        if (invalidStep) show(Number(invalidStep.dataset.step));
        invalid.reportValidity();
      }, true);

      syncVariant();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-cover-form]').forEach(initializeCoverForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-cover-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCoverForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CoverProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const variants = JSON.parse(root.querySelector('[data-cover-variant-map]')?.textContent || '[]');
      const isCustom = root.dataset.isCustom === 'true';
      const sizeChoice = root.querySelector('[data-cover-size]');
      const colorChoice = root.querySelector('[data-cover-color]');
      const customizationChoice = root.querySelector('[data-cover-customization]');
      const textField = root.querySelector('[data-cover-text-field]');
      const logoField = root.querySelector('[data-cover-logo-field]');
      const studentField = root.querySelector('[data-cover-student-field]');
      const progress = root.querySelector('.sdd-cover-form__progress');
      const ready = root.querySelector('.sdd-cover-form__ready');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const reviewSelectionLists = root.querySelectorAll('[data-review-selections]');
      const reviewCostLists = root.querySelectorAll('[data-review-costs]');
      const reviewTotals = root.querySelectorAll('[data-review-total]');
      let step = 1;

      const selectedVariant = () => variants.find((variant) => (
        String(variant.size || '') === String(sizeChoice?.value || '')
        && String(variant.color || '') === String(colorChoice?.value || '')
        && String(variant.customization || '') === String(customizationChoice?.value || '')
      )) || variants[0];

      const currentQuantity = () => Number(productForm.querySelector('[name="quantity"]')?.value || 1);
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);

      const syncVariant = () => {
        const match = selectedVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      const setFieldState = (field, active) => {
        if (!field) return;
        const input = field.querySelector('input, textarea, select');
        field.hidden = !active;
        if (!input) return;
        input.disabled = !active;
        input.required = active;
      };

      const updateConditionalFields = () => {
        const choice = String(customizationChoice?.value || '').toLowerCase();
        const needsStudent = choice.includes('student name');
        if (isCustom) {
          setFieldState(textField, choice.includes('text'));
          setFieldState(logoField, choice.includes('logo'));
          setFieldState(studentField, needsStudent);
        } else {
          setFieldState(studentField, needsStudent);
        }
      };

      const calculateTotal = () => Number(selectedVariant()?.price || 0) * currentQuantity();
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };

      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };

      const renderSelections = (list) => {
        list.replaceChildren();
        addReviewRow(list, 'Cover size', sizeChoice?.value || '');
        addReviewRow(list, 'Cover color', colorChoice?.value || '');
        addReviewRow(list, isCustom ? 'Customization' : 'Personalization', customizationChoice?.value || '');

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          let label = control.name.slice(11, -1).replace(/:$/, '').trim();
          const friendlyLabels = {
            'Folder option - standard': 'Standard folder option',
            'Text Customization Here If Applicable': 'Text customization',
            'Logo Customization Customization, If Applicable': 'Logo customization',
            'Student Name If Applicable': 'Student name'
          };
          label = friendlyLabels[label] || label;
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT'
            ? control.selectedOptions[0]?.textContent.trim()
            : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(list, label, value);
        });
      };

      const renderCosts = (list) => {
        list.replaceChildren();
        const quantity = currentQuantity();
        addReviewRow(
          list,
          root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''),
          formatMoney(calculateTotal())
        );
      };

      const renderReview = () => {
        reviewSelectionLists.forEach(renderSelections);
        reviewCostLists.forEach(renderCosts);
        reviewTotals.forEach((element) => { element.textContent = formatMoney(calculateTotal()); });
      };

      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => {
          section.hidden = Number(section.dataset.step) !== number;
        });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
        if (number === 3) renderReview();
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-cover-size], [data-cover-color], [data-cover-customization]')) {
          syncVariant();
          updateConditionalFields();
        }
        updateLiveTotal();
        if (!ready.hidden || step === 3) renderReview();
      });

      productForm.addEventListener('input', () => {
        updateLiveTotal();
        if (!ready.hidden || step === 3) renderReview();
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', (event) => {
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (!invalid) return;
        event.preventDefault();
        const invalidStep = invalid.closest('[data-step]');
        ready.hidden = true;
        progress.hidden = false;
        if (invalidStep) show(Number(invalidStep.dataset.step));
        invalid.reportValidity();
      }, true);

      syncVariant();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-cover-form]').forEach(initializeCoverForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-cover-standard-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCoverForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CoverProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const variants = JSON.parse(root.querySelector('[data-cover-variant-map]')?.textContent || '[]');
      const isCustom = root.dataset.isCustom === 'true';
      const sizeChoice = root.querySelector('[data-cover-size]');
      const colorChoice = root.querySelector('[data-cover-color]');
      const customizationChoice = root.querySelector('[data-cover-customization]');
      const textField = root.querySelector('[data-cover-text-field]');
      const logoField = root.querySelector('[data-cover-logo-field]');
      const studentField = root.querySelector('[data-cover-student-field]');
      const progress = root.querySelector('.sdd-cover-form__progress');
      const ready = root.querySelector('.sdd-cover-form__ready');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const reviewSelectionLists = root.querySelectorAll('[data-review-selections]');
      const reviewCostLists = root.querySelectorAll('[data-review-costs]');
      const reviewTotals = root.querySelectorAll('[data-review-total]');
      let step = 1;

      const selectedVariant = () => variants.find((variant) => (
        String(variant.size || '') === String(sizeChoice?.value || '')
        && String(variant.color || '') === String(colorChoice?.value || '')
        && String(variant.customization || '') === String(customizationChoice?.value || '')
      )) || variants[0];

      const currentQuantity = () => Number(productForm.querySelector('[name="quantity"]')?.value || 1);
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);

      const syncVariant = () => {
        const match = selectedVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      const setFieldState = (field, active) => {
        if (!field) return;
        const input = field.querySelector('input, textarea, select');
        field.hidden = !active;
        if (!input) return;
        input.disabled = !active;
        input.required = active;
      };

      const updateConditionalFields = () => {
        const choice = String(customizationChoice?.value || '').toLowerCase();
        const needsStudent = choice.includes('student name');
        if (isCustom) {
          setFieldState(textField, choice.includes('text'));
          setFieldState(logoField, choice.includes('logo'));
          setFieldState(studentField, needsStudent);
        } else {
          setFieldState(studentField, needsStudent);
        }
      };

      const calculateTotal = () => Number(selectedVariant()?.price || 0) * currentQuantity();
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };

      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };

      const renderSelections = (list) => {
        list.replaceChildren();
        addReviewRow(list, 'Cover size', sizeChoice?.value || '');
        addReviewRow(list, 'Cover color', colorChoice?.value || '');
        addReviewRow(list, isCustom ? 'Customization' : 'Personalization', customizationChoice?.value || '');

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          let label = control.name.slice(11, -1).replace(/:$/, '').trim();
          const friendlyLabels = {
            'Folder option - standard': 'Standard folder option',
            'Text Customization Here If Applicable': 'Text customization',
            'Logo Customization Customization, If Applicable': 'Logo customization',
            'Student Name If Applicable': 'Student name'
          };
          label = friendlyLabels[label] || label;
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT'
            ? control.selectedOptions[0]?.textContent.trim()
            : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(list, label, value);
        });
      };

      const renderCosts = (list) => {
        list.replaceChildren();
        const quantity = currentQuantity();
        addReviewRow(
          list,
          root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''),
          formatMoney(calculateTotal())
        );
      };

      const renderReview = () => {
        reviewSelectionLists.forEach(renderSelections);
        reviewCostLists.forEach(renderCosts);
        reviewTotals.forEach((element) => { element.textContent = formatMoney(calculateTotal()); });
      };

      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => {
          section.hidden = Number(section.dataset.step) !== number;
        });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
        if (number === 3) renderReview();
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-cover-size], [data-cover-color], [data-cover-customization]')) {
          syncVariant();
          updateConditionalFields();
        }
        updateLiveTotal();
        if (!ready.hidden || step === 3) renderReview();
      });

      productForm.addEventListener('input', () => {
        updateLiveTotal();
        if (!ready.hidden || step === 3) renderReview();
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', (event) => {
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (!invalid) return;
        event.preventDefault();
        const invalidStep = invalid.closest('[data-step]');
        ready.hidden = true;
        progress.hidden = false;
        if (invalidStep) show(Number(invalidStep.dataset.step));
        invalid.reportValidity();
      }, true);

      syncVariant();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-cover-form]').forEach(initializeCoverForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-associate-bundle-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-associate-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-bachelor-bundle-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-bachelor-diploma-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-bachelor-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-master-bundle-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-master-diploma-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-master-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-phd-bundle-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-phd-diploma-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-degree-phd-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'degree' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-canada-secondary-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && !syncNativeState()) {
          if (nativeStateError) nativeStateError.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-canada-secondary-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && !syncNativeState()) {
          if (nativeStateError) nativeStateError.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-college-stock-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'college' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const referenceFile = root.querySelector('[data-native-reference-file]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);
      const validateReferenceFile = () => {
        if (!referenceFile) return true;
        const file = referenceFile.files?.[0];
        let message = '';
        if (file && !/\.(pdf|jpe?g|png|heic|heif)$/i.test(file.name)) {
          message = 'Please upload a PDF, JPG, JPEG, PNG, HEIC or HEIF file.';
        } else if (file && file.size > 20 * 1024 * 1024) {
          message = 'Please choose a file that is 20 MB or smaller.';
        }
        referenceFile.setCustomValidity(message);
        return !message;
      };

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        validateReferenceFile();
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        if (referenceFile?.files?.[0]) addReviewRow(reviewSelections, 'Example / Reference File', referenceFile.files[0].name);

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-native-reference-file]')) validateReferenceFile();
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        validateReferenceFile();
        const invalid = [...root.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        syncDeliveryProperty();
        const addons = selectedAddonEntries();
        const hasReferenceFile = Boolean(referenceFile?.files?.length);
        const deliveryInput = selectedDelivery();
        const deliveryKind = String(deliveryInput?.dataset.deliveryKind || 'digital');
        const needsShippingLine = deliveryKind === 'printed' || deliveryKind === 'both';

        if (needsShippingLine) {
          const shippingAddonId = deliveryInput?.dataset?.addon;
          if (!shippingAddonId) {
            event.preventDefault();
            event.stopImmediatePropagation();
            errorBox.textContent = 'Printed delivery is not available right now. Please choose digital delivery or contact us for help.';
            errorBox.hidden = false;
            return;
          }
          if (!addons.some((entry) => String(entry.id) === String(shippingAddonId))) {
            addons.push({
              id: Number(shippingAddonId),
              quantity: 1,
              price: optionPrice(deliveryInput),
              label: cleanLabel(deliveryInput.value)
            });
          }
        }

        if (!usesFormDelivery && !addons.length && !hasReferenceFile) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        formData.delete('sdd_college_delivery');
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (value instanceof File) continue;
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const addonItems = addons.map((entry) => ({
          id: entry.id,
          quantity: entry.quantity,
          properties: addonProperties
        }));

        try {
          if (hasReferenceFile) {
            const mainResponse = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData
            });
            if (!mainResponse.ok) throw new Error('Main product upload failed');
            const mainLine = await mainResponse.json();

            if (addonItems.length) {
              const addonResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: addonItems })
              });
              if (!addonResponse.ok) {
                if (mainLine?.key) {
                  await fetch(root.dataset.cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: mainLine.key, quantity: 0 })
                  }).catch(() => {});
                }
                throw new Error('Add-on request failed');
              }
            }
          } else {
            const items = [
              { id: variantId, quantity, properties },
              ...addonItems
            ];
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-college-stock-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'college' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      const referenceFile = root.querySelector('[data-native-reference-file]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);
      const validateReferenceFile = () => {
        if (!referenceFile) return true;
        const file = referenceFile.files?.[0];
        let message = '';
        if (file && !/\.(pdf|jpe?g|png|heic|heif)$/i.test(file.name)) {
          message = 'Please upload a PDF, JPG, JPEG, PNG, HEIC or HEIF file.';
        } else if (file && file.size > 20 * 1024 * 1024) {
          message = 'Please choose a file that is 20 MB or smaller.';
        }
        referenceFile.setCustomValidity(message);
        return !message;
      };

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        validateReferenceFile();
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        if (referenceFile?.files?.[0]) addReviewRow(reviewSelections, 'Example / Reference File', referenceFile.files[0].name);

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-native-reference-file]')) validateReferenceFile();
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        validateReferenceFile();
        const invalid = [...root.querySelectorAll('[required]:not(:disabled), [data-native-reference-file]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        syncDeliveryProperty();
        const deliveryInput = selectedDelivery();
        const deliveryKind = String(deliveryInput?.dataset.deliveryKind || 'digital');
        const needsShippingLine = deliveryKind === 'printed' || deliveryKind === 'both';

        // Printed/both must never fall through to Impulse's digital-only native submit.
        if (needsShippingLine) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        let addons = [];
        try {
          addons = selectedAddonEntries();
        } catch (error) {
          addons = [];
        }
        const hasReferenceFile = Boolean(referenceFile?.files?.length);

        if (needsShippingLine) {
          const shippingAddonId = deliveryInput?.dataset?.addon;
          if (!shippingAddonId) {
            errorBox.textContent = 'Printed delivery is not available right now. Please choose digital delivery or contact us for help.';
            errorBox.hidden = false;
            return;
          }
          if (!addons.some((entry) => String(entry.id) === String(shippingAddonId))) {
            addons.push({
              id: Number(shippingAddonId),
              quantity: 1,
              price: optionPrice(deliveryInput),
              label: cleanLabel(deliveryInput.value)
            });
          }
        }

        if (!usesFormDelivery && !addons.length && !hasReferenceFile) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        formData.delete('sdd_college_delivery');
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (value instanceof File) continue;
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'College order', '_Parent product': root.dataset.productTitle };
        const addonItems = addons.map((entry) => ({
          id: entry.id,
          quantity: entry.quantity,
          properties: addonProperties
        }));

        try {
          if (hasReferenceFile) {
            const mainResponse = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData
            });
            if (!mainResponse.ok) throw new Error('Main product upload failed');
            const mainLine = await mainResponse.json();

            if (addonItems.length) {
              const addonResponse = await fetch(root.dataset.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: addonItems })
              });
              if (!addonResponse.ok) {
                if (mainLine?.key) {
                  await fetch(root.dataset.cartChangeUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: mainLine.key, quantity: 0 })
                  }).catch(() => {});
                }
                throw new Error('Add-on request failed');
              }
            }
          } else {
            const items = [
              { id: variantId, quantity, properties },
              ...addonItems
            ];
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
          }
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-ged-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeGedForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';

      root.dataset.ready = 'true';

      const removeOldForm = () => {
        const oldForm = document.querySelector('#infiniteoptions-container');
        if (oldForm) oldForm.remove();
      };

      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'GedProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }

      root.querySelectorAll('input, textarea, select').forEach((control) => {
        control.setAttribute('form', productFormId);
      });

      const progress = root.querySelector('.sdd-ged-form__progress');
      const ready = root.querySelector('.sdd-ged-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };

      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);

      const priceFromText = (value) => {
        const match = String(value || '').match(/\+\s*\$([\d,]+(?:\.\d{1,2})?)/);
        return match ? Math.round(Number(match[1].replace(/,/g, '')) * 100) : 0;
      };

      const cleanCostLabel = (value) => String(value || '')
        .replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '')
        .trim();

      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };

      const addCostRow = (label, cents) => {
        addReviewRow(reviewCosts, label, formatMoney(cents));
      };

      const selectedDelivery = () => root.querySelector('input[name="sdd_ged_delivery"]:checked');
      const isPrinted = () => Boolean(selectedDelivery()?.dataset.addon);

      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const hasSelectedFolder = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !hasSelectedFolder;
        folderColor.disabled = !hasSelectedFolder;
        folderColor.required = hasSelectedFolder;
      };

      const updateConditionalFields = () => {
        const printed = isPrinted();
        if (deliveryProperty && selectedDelivery()) deliveryProperty.value = selectedDelivery().value;
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        if (proofSelect) proofSelect.disabled = !printed;
        if (folderSelect) folderSelect.disabled = !printed;
        digitalNote.hidden = printed;
        setFolderState();
      };

      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => {
          section.hidden = Number(section.dataset.step) !== number;
        });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          const active = index < number;
          indicator.classList.toggle('is-active', active);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };

      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => {
          field.setAttribute('aria-invalid', String(!field.checkValidity()));
        });
        if (invalid) {
          invalid.reportValidity();
          return false;
        }
        return true;
      };

      const folderAddonId = () => {
        if (!folderSelect || !folderColor || folderColor.disabled) return '';
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
        const colorOption = folderColor.selectedOptions[0];
        if (!folderKey || folderKey === 'none' || !colorOption) return '';
        const key = folderKey + 'Addon';
        return colorOption.dataset[key] || '';
      };

      const collectAddons = () => {
        const ids = [];
        const deliveryId = selectedDelivery()?.dataset.addon;
        const proofId = isPrinted() ? proofSelect?.selectedOptions[0]?.dataset.addon : '';
        const folderId = folderAddonId();
        [deliveryId, proofId, folderId].forEach((id) => {
          if (id) ids.push(Number(id));
        });
        return ids;
      };

      const calculateTotal = () => {
        const variant = currentVariant();
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          total += priceFromText(delivery.closest('label')?.textContent || delivery.value);
        }

        if (isPrinted()) {
          const proof = proofSelect?.selectedOptions[0];
          if (proof?.dataset.addon) total += priceFromText(proof.textContent);

          if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
            total += Number(folderColor.selectedOptions[0]?.dataset[folderKey + 'Price'] || 0);
          }
        }

        return total;
      };

      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };

      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();

        const variant = currentVariant();
        if (variant?.title && variant.title !== 'Default Title') {
          addReviewRow(reviewSelections, root.dataset.labelProductOption, variant.title);
        }

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;

          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;

          const value = control.tagName === 'SELECT'
            ? control.selectedOptions[0]?.textContent.trim()
            : String(control.value || '').trim();
          if (!value) return;

          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;
        addCostRow(root.dataset.productTitle, total);

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          const text = delivery.closest('label')?.textContent || delivery.value;
          const cents = priceFromText(text);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(delivery.value), cents);
          }
        }

        const proof = proofSelect?.selectedOptions[0];
        if (isPrinted() && proof?.dataset.addon) {
          const cents = priceFromText(proof.textContent);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(proof.textContent), cents);
          }
        }

        if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
          const folderOption = folderSelect.selectedOptions[0];
          const colorOption = folderColor.selectedOptions[0];
          const folderKey = folderOption?.dataset.folderKey;
          const cents = Number(colorOption?.dataset[folderKey + 'Price'] || 0);
          if (cents) {
            total += cents;
            addCostRow(
              folderOption.textContent.trim() + ' — ' + colorOption.textContent.trim(),
              cents
            );
          }
        }

        reviewTotal.textContent = formatMoney(total);
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_ged_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addonIds = collectAddons();
        if (!addonIds.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') {
            properties[name.slice(11, -1)] = value;
          }
        }

        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = {
          '_Added with': 'GED order',
          '_Parent product': root.dataset.productTitle
        };
        const items = [
          { id: variantId, quantity, properties },
          ...addonIds.map((id) => ({ id, quantity: 1, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = root.dataset.errorAdd;
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }

      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach(initializeGedForm);
    };

    const restoreDefaultDeliveries = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach((root) => {
        const selected = root.querySelector('input[name="sdd_ged_delivery"]:checked');
        if (selected) return;
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (!defaultDelivery) return;
        defaultDelivery.checked = true;
        defaultDelivery.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();

    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', restoreDefaultDeliveries);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-ged-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeGedForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';

      root.dataset.ready = 'true';

      const removeOldForm = () => {
        const oldForm = document.querySelector('#infiniteoptions-container');
        if (oldForm) oldForm.remove();
      };

      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'GedProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }

      root.querySelectorAll('input, textarea, select').forEach((control) => {
        control.setAttribute('form', productFormId);
      });

      const progress = root.querySelector('.sdd-ged-form__progress');
      const ready = root.querySelector('.sdd-ged-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };

      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);

      const priceFromText = (value) => {
        const match = String(value || '').match(/\+\s*\$([\d,]+(?:\.\d{1,2})?)/);
        return match ? Math.round(Number(match[1].replace(/,/g, '')) * 100) : 0;
      };

      const cleanCostLabel = (value) => String(value || '')
        .replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '')
        .trim();

      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };

      const addCostRow = (label, cents) => {
        addReviewRow(reviewCosts, label, formatMoney(cents));
      };

      const selectedDelivery = () => root.querySelector('input[name="sdd_ged_delivery"]:checked');
      const isPrinted = () => Boolean(selectedDelivery()?.dataset.addon);

      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const hasSelectedFolder = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !hasSelectedFolder;
        folderColor.disabled = !hasSelectedFolder;
        folderColor.required = hasSelectedFolder;
      };

      const updateConditionalFields = () => {
        const printed = isPrinted();
        if (deliveryProperty && selectedDelivery()) deliveryProperty.value = selectedDelivery().value;
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        if (proofSelect) proofSelect.disabled = !printed;
        if (folderSelect) folderSelect.disabled = !printed;
        digitalNote.hidden = printed;
        setFolderState();
      };

      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => {
          section.hidden = Number(section.dataset.step) !== number;
        });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          const active = index < number;
          indicator.classList.toggle('is-active', active);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };

      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => {
          field.setAttribute('aria-invalid', String(!field.checkValidity()));
        });
        if (invalid) {
          invalid.reportValidity();
          return false;
        }
        return true;
      };

      const folderAddonId = () => {
        if (!folderSelect || !folderColor || folderColor.disabled) return '';
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
        const colorOption = folderColor.selectedOptions[0];
        if (!folderKey || folderKey === 'none' || !colorOption) return '';
        const key = folderKey + 'Addon';
        return colorOption.dataset[key] || '';
      };

      const collectAddons = () => {
        const ids = [];
        const deliveryId = selectedDelivery()?.dataset.addon;
        const proofId = isPrinted() ? proofSelect?.selectedOptions[0]?.dataset.addon : '';
        const folderId = folderAddonId();
        [deliveryId, proofId, folderId].forEach((id) => {
          if (id) ids.push(Number(id));
        });
        return ids;
      };

      const calculateTotal = () => {
        const variant = currentVariant();
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          total += priceFromText(delivery.closest('label')?.textContent || delivery.value);
        }

        if (isPrinted()) {
          const proof = proofSelect?.selectedOptions[0];
          if (proof?.dataset.addon) total += priceFromText(proof.textContent);

          if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
            total += Number(folderColor.selectedOptions[0]?.dataset[folderKey + 'Price'] || 0);
          }
        }

        return total;
      };

      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };

      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();

        const variant = currentVariant();
        if (variant?.title && variant.title !== 'Default Title') {
          addReviewRow(reviewSelections, root.dataset.labelProductOption, variant.title);
        }

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;

          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;

          const value = control.tagName === 'SELECT'
            ? control.selectedOptions[0]?.textContent.trim()
            : String(control.value || '').trim();
          if (!value) return;

          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;
        addCostRow(root.dataset.productTitle, total);

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          const text = delivery.closest('label')?.textContent || delivery.value;
          const cents = priceFromText(text);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(delivery.value), cents);
          }
        }

        const proof = proofSelect?.selectedOptions[0];
        if (isPrinted() && proof?.dataset.addon) {
          const cents = priceFromText(proof.textContent);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(proof.textContent), cents);
          }
        }

        if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
          const folderOption = folderSelect.selectedOptions[0];
          const colorOption = folderColor.selectedOptions[0];
          const folderKey = folderOption?.dataset.folderKey;
          const cents = Number(colorOption?.dataset[folderKey + 'Price'] || 0);
          if (cents) {
            total += cents;
            addCostRow(
              folderOption.textContent.trim() + ' — ' + colorOption.textContent.trim(),
              cents
            );
          }
        }

        reviewTotal.textContent = formatMoney(total);
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_ged_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addonIds = collectAddons();
        if (!addonIds.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') {
            properties[name.slice(11, -1)] = value;
          }
        }

        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = {
          '_Added with': 'GED order',
          '_Parent product': root.dataset.productTitle
        };
        const items = [
          { id: variantId, quantity, properties },
          ...addonIds.map((id) => ({ id, quantity: 1, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = root.dataset.errorAdd;
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }

      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach(initializeGedForm);
    };

    const restoreDefaultDeliveries = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach((root) => {
        const selected = root.querySelector('input[name="sdd_ged_delivery"]:checked');
        if (selected) return;
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (!defaultDelivery) return;
        defaultDelivery.checked = true;
        defaultDelivery.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();

    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', restoreDefaultDeliveries);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-hs-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && !syncNativeState()) {
          if (nativeStateError) nativeStateError.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-hs-state-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const variantState = (variant) => String(variant?.state || variant?.option1 || variant?.options?.[0] || '').trim();
      const variantDelivery = (variant) => String(variant?.delivery || variant?.option2 || variant?.options?.[1] || '').trim();
      const validStateValue = (state) => state !== '' && !/^choose\s+your\s+state$/i.test(state);
      const setVariantId = (match) => {
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return false;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      };
      const syncNativeState = () => {
        const state = isStateDelivery
          ? String(stateSelect?.value || '').trim()
          : variantState(currentVariant());
        const valid = validStateValue(state);
        if (nativeStateProperty) nativeStateProperty.value = valid ? state : '';
        if (nativeStateError) {
          if (valid) nativeStateError.hidden = true;
          else nativeStateError.textContent = 'Please choose your state before continuing.';
        }

        if (valid) {
          const activeVariant = currentVariant();
          const mediaVariant = variantState(activeVariant) === state && activeVariant?.featured_media
            ? activeVariant
            : variants.find((candidate) => variantState(candidate) === state && candidate?.featured_media);
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const selectedState = () => isStateDelivery
        ? String(stateSelect?.value || '').trim()
        : variantState(currentVariant());
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const state = selectedState();
        return nativeVariants.find((variant) => {
          const deliveryMatches = variantDelivery(variant) === delivery;
          const stateMatches = !isStateDelivery || variantState(variant) === state;
          return deliveryMatches && stateMatches;
        }) || null;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery) return true;
        if (!syncNativeState()) return false;
        const state = selectedState();
        const match = hasNativeDelivery
          ? selectedNativeVariant()
          : nativeVariants.find((variant) => variantState(variant) === state);
        return setVariantId(match);
      };
      const syncNativeVariant = () => {
        if (!hasNativeDelivery) return true;
        return setVariantId(selectedNativeVariant());
      };
      const syncControlsFromCurrentVariant = () => {
        if (!isStateDelivery) return;
        const variant = currentVariant();
        const state = variantState(variant);
        if (stateSelect && validStateValue(state) && [...stateSelect.options].some((option) => option.value === state)) {
          stateSelect.value = state;
        }
        if (hasNativeDelivery) {
          const delivery = variantDelivery(variant);
          const input = [...root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]')]
            .find((candidate) => String(candidate.dataset.optionValue || '') === delivery);
          if (input) input.checked = true;
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1) {
          const stateValid = syncNativeState();
          const variantValid = stateValid && syncStateVariant() && syncNativeVariant();
          if (!variantValid) {
            if (nativeStateError) {
              nativeStateError.textContent = stateValid
                ? 'That state and delivery combination is unavailable. Please choose another option.'
                : 'Please choose your state before continuing.';
              nativeStateError.hidden = false;
            }
            return false;
          }
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const stateValid = syncNativeState();
        const variantValid = stateValid && syncStateVariant() && syncNativeVariant();
        if (!variantValid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) {
            nativeStateError.textContent = stateValid
              ? 'That state and delivery combination is unavailable. Please choose another option.'
              : 'Please choose your state before continuing.';
            nativeStateError.hidden = false;
          }
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      syncControlsFromCurrentVariant();
      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-hs-state-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const variantState = (variant) => String(variant?.state || variant?.option1 || variant?.options?.[0] || '').trim();
      const variantDelivery = (variant) => String(variant?.delivery || variant?.option2 || variant?.options?.[1] || '').trim();
      const validStateValue = (state) => state !== '' && !/^choose\s+your\s+state$/i.test(state);
      const setVariantId = (match) => {
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return false;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      };
      const syncNativeState = () => {
        const state = isStateDelivery
          ? String(stateSelect?.value || '').trim()
          : variantState(currentVariant());
        const valid = validStateValue(state);
        if (nativeStateProperty) nativeStateProperty.value = valid ? state : '';
        if (nativeStateError) {
          if (valid) nativeStateError.hidden = true;
          else nativeStateError.textContent = 'Please choose your state before continuing.';
        }

        if (valid) {
          const activeVariant = currentVariant();
          const mediaVariant = variantState(activeVariant) === state && activeVariant?.featured_media
            ? activeVariant
            : variants.find((candidate) => variantState(candidate) === state && candidate?.featured_media);
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const selectedState = () => isStateDelivery
        ? String(stateSelect?.value || '').trim()
        : variantState(currentVariant());
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const state = selectedState();
        return nativeVariants.find((variant) => {
          const deliveryMatches = variantDelivery(variant) === delivery;
          const stateMatches = !isStateDelivery || variantState(variant) === state;
          return deliveryMatches && stateMatches;
        }) || null;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery) return true;
        if (!syncNativeState()) return false;
        const state = selectedState();
        const match = hasNativeDelivery
          ? selectedNativeVariant()
          : nativeVariants.find((variant) => variantState(variant) === state);
        return setVariantId(match);
      };
      const syncNativeVariant = () => {
        if (!hasNativeDelivery) return true;
        return setVariantId(selectedNativeVariant());
      };
      const syncControlsFromCurrentVariant = () => {
        if (!isStateDelivery) return;
        const variant = currentVariant();
        const state = variantState(variant);
        if (stateSelect && validStateValue(state) && [...stateSelect.options].some((option) => option.value === state)) {
          stateSelect.value = state;
        }
        if (hasNativeDelivery) {
          const delivery = variantDelivery(variant);
          const input = [...root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]')]
            .find((candidate) => String(candidate.dataset.optionValue || '') === delivery);
          if (input) input.checked = true;
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        const state = selectedState();
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const delivery = String(input.dataset.optionValue || '');
          const match = selectedNativeVariant(input)
            || (!state ? nativeVariants.find((variant) => variantDelivery(variant) === delivery) : null);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1) {
          const stateValid = syncNativeState();
          const variantValid = stateValid && syncStateVariant() && syncNativeVariant();
          if (!variantValid) {
            if (nativeStateError) {
              nativeStateError.textContent = stateValid
                ? 'That state and delivery combination is unavailable. Please choose another option.'
                : 'Please choose your state before continuing.';
              nativeStateError.hidden = false;
            }
            return false;
          }
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const pricingVariant = () => {
        const selected = hasNativeDelivery ? selectedNativeVariant() : null;
        return selected || currentVariant();
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(pricingVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = pricingVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) {
          syncStateVariant();
          updateDeliveryPrices();
        }
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const stateValid = syncNativeState();
        const variantValid = stateValid && syncStateVariant() && syncNativeVariant();
        if (!variantValid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) {
            nativeStateError.textContent = stateValid
              ? 'That state and delivery combination is unavailable. Please choose another option.'
              : 'Please choose your state before continuing.';
            nativeStateError.hidden = false;
          }
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      syncControlsFromCurrentVariant();
      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-form-spanish-secondary-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && !syncNativeState()) {
          if (nativeStateError) nativeStateError.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-ged-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeGedForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';

      root.dataset.ready = 'true';

      const removeOldForm = () => {
        const oldForm = document.querySelector('#infiniteoptions-container');
        if (oldForm) oldForm.remove();
      };

      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'GedProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }

      root.querySelectorAll('input, textarea, select').forEach((control) => {
        control.setAttribute('form', productFormId);
      });

      const progress = root.querySelector('.sdd-ged-form__progress');
      const ready = root.querySelector('.sdd-ged-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };

      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);

      const priceFromText = (value) => {
        const match = String(value || '').match(/\+\s*\$([\d,]+(?:\.\d{1,2})?)/);
        return match ? Math.round(Number(match[1].replace(/,/g, '')) * 100) : 0;
      };

      const cleanCostLabel = (value) => String(value || '')
        .replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '')
        .trim();

      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };

      const addCostRow = (label, cents) => {
        addReviewRow(reviewCosts, label, formatMoney(cents));
      };

      const selectedDelivery = () => root.querySelector('input[name="sdd_ged_delivery"]:checked');
      const isPrinted = () => Boolean(selectedDelivery()?.dataset.addon);

      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const hasSelectedFolder = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !hasSelectedFolder;
        folderColor.disabled = !hasSelectedFolder;
        folderColor.required = hasSelectedFolder;
      };

      const updateConditionalFields = () => {
        const printed = isPrinted();
        if (deliveryProperty && selectedDelivery()) deliveryProperty.value = selectedDelivery().value;
        printUpgrades.hidden = !printed;
        if (proofSelect) proofSelect.disabled = !printed;
        if (folderSelect) folderSelect.disabled = !printed;
        digitalNote.hidden = printed;
        setFolderState();
      };

      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => {
          section.hidden = Number(section.dataset.step) !== number;
        });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          const active = index < number;
          indicator.classList.toggle('is-active', active);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };

      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => {
          field.setAttribute('aria-invalid', String(!field.checkValidity()));
        });
        if (invalid) {
          invalid.reportValidity();
          return false;
        }
        return true;
      };

      const folderAddonId = () => {
        if (!folderSelect || !folderColor || folderColor.disabled) return '';
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
        const colorOption = folderColor.selectedOptions[0];
        if (!folderKey || folderKey === 'none' || !colorOption) return '';
        const key = folderKey + 'Addon';
        return colorOption.dataset[key] || '';
      };

      const collectAddons = () => {
        const ids = [];
        const deliveryId = selectedDelivery()?.dataset.addon;
        const proofId = isPrinted() ? proofSelect?.selectedOptions[0]?.dataset.addon : '';
        const folderId = folderAddonId();
        [deliveryId, proofId, folderId].forEach((id) => {
          if (id) ids.push(Number(id));
        });
        return ids;
      };

      const calculateTotal = () => {
        const variant = currentVariant();
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          total += priceFromText(delivery.closest('label')?.textContent || delivery.value);
        }

        if (isPrinted()) {
          const proof = proofSelect?.selectedOptions[0];
          if (proof?.dataset.addon) total += priceFromText(proof.textContent);

          if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
            total += Number(folderColor.selectedOptions[0]?.dataset[folderKey + 'Price'] || 0);
          }
        }

        return total;
      };

      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };

      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();

        const variant = currentVariant();
        if (variant?.title && variant.title !== 'Default Title') {
          addReviewRow(reviewSelections, root.dataset.labelProductOption, variant.title);
        }

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;

          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;

          const value = control.tagName === 'SELECT'
            ? control.selectedOptions[0]?.textContent.trim()
            : String(control.value || '').trim();
          if (!value) return;

          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;
        addCostRow(root.dataset.productTitle, total);

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          const text = delivery.closest('label')?.textContent || delivery.value;
          const cents = priceFromText(text);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(delivery.value), cents);
          }
        }

        const proof = proofSelect?.selectedOptions[0];
        if (isPrinted() && proof?.dataset.addon) {
          const cents = priceFromText(proof.textContent);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(proof.textContent), cents);
          }
        }

        if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
          const folderOption = folderSelect.selectedOptions[0];
          const colorOption = folderColor.selectedOptions[0];
          const folderKey = folderOption?.dataset.folderKey;
          const cents = Number(colorOption?.dataset[folderKey + 'Price'] || 0);
          if (cents) {
            total += cents;
            addCostRow(
              folderOption.textContent.trim() + ' — ' + colorOption.textContent.trim(),
              cents
            );
          }
        }

        reviewTotal.textContent = formatMoney(total);
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_ged_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addonIds = collectAddons();
        if (!addonIds.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') {
            properties[name.slice(11, -1)] = value;
          }
        }

        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = {
          '_Added with': 'GED order',
          '_Parent product': root.dataset.productTitle
        };
        const items = [
          { id: variantId, quantity, properties },
          ...addonIds.map((id) => ({ id, quantity: 1, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = root.dataset.errorAdd;
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }

      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach(initializeGedForm);
    };

    const restoreDefaultDeliveries = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach((root) => {
        const selected = root.querySelector('input[name="sdd_ged_delivery"]:checked');
        if (selected) return;
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (!defaultDelivery) return;
        defaultDelivery.checked = true;
        defaultDelivery.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();

    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', restoreDefaultDeliveries);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-ged-replica-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeGedForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';

      root.dataset.ready = 'true';

      const removeOldForm = () => {
        const oldForm = document.querySelector('#infiniteoptions-container');
        if (oldForm) oldForm.remove();
      };

      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'GedProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }

      root.querySelectorAll('input, textarea, select').forEach((control) => {
        control.setAttribute('form', productFormId);
      });

      const progress = root.querySelector('.sdd-ged-form__progress');
      const ready = root.querySelector('.sdd-ged-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };

      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);

      const priceFromText = (value) => {
        const match = String(value || '').match(/\+\s*\$([\d,]+(?:\.\d{1,2})?)/);
        return match ? Math.round(Number(match[1].replace(/,/g, '')) * 100) : 0;
      };

      const cleanCostLabel = (value) => String(value || '')
        .replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '')
        .trim();

      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };

      const addCostRow = (label, cents) => {
        addReviewRow(reviewCosts, label, formatMoney(cents));
      };

      const selectedDelivery = () => root.querySelector('input[name="sdd_ged_delivery"]:checked');
      const isPrinted = () => Boolean(selectedDelivery()?.dataset.addon);

      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const hasSelectedFolder = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !hasSelectedFolder;
        folderColor.disabled = !hasSelectedFolder;
        folderColor.required = hasSelectedFolder;
      };

      const updateConditionalFields = () => {
        const printed = isPrinted();
        if (deliveryProperty && selectedDelivery()) deliveryProperty.value = selectedDelivery().value;
        printUpgrades.hidden = !printed;
        if (proofSelect) proofSelect.disabled = !printed;
        if (folderSelect) folderSelect.disabled = !printed;
        digitalNote.hidden = printed;
        setFolderState();
      };

      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => {
          section.hidden = Number(section.dataset.step) !== number;
        });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          const active = index < number;
          indicator.classList.toggle('is-active', active);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };

      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => {
          field.setAttribute('aria-invalid', String(!field.checkValidity()));
        });
        if (invalid) {
          invalid.reportValidity();
          return false;
        }
        return true;
      };

      const folderAddonId = () => {
        if (!folderSelect || !folderColor || folderColor.disabled) return '';
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
        const colorOption = folderColor.selectedOptions[0];
        if (!folderKey || folderKey === 'none' || !colorOption) return '';
        const key = folderKey + 'Addon';
        return colorOption.dataset[key] || '';
      };

      const collectAddons = () => {
        const ids = [];
        const deliveryId = selectedDelivery()?.dataset.addon;
        const proofId = isPrinted() ? proofSelect?.selectedOptions[0]?.dataset.addon : '';
        const folderId = folderAddonId();
        [deliveryId, proofId, folderId].forEach((id) => {
          if (id) ids.push(Number(id));
        });
        return ids;
      };

      const calculateTotal = () => {
        const variant = currentVariant();
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          total += priceFromText(delivery.closest('label')?.textContent || delivery.value);
        }

        if (isPrinted()) {
          const proof = proofSelect?.selectedOptions[0];
          if (proof?.dataset.addon) total += priceFromText(proof.textContent);

          if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
            total += Number(folderColor.selectedOptions[0]?.dataset[folderKey + 'Price'] || 0);
          }
        }

        return total;
      };

      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };

      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();

        const variant = currentVariant();
        if (variant?.title && variant.title !== 'Default Title') {
          addReviewRow(reviewSelections, root.dataset.labelProductOption, variant.title);
        }

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;

          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;

          const value = control.tagName === 'SELECT'
            ? control.selectedOptions[0]?.textContent.trim()
            : String(control.value || '').trim();
          if (!value) return;

          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;
        addCostRow(root.dataset.productTitle, total);

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          const text = delivery.closest('label')?.textContent || delivery.value;
          const cents = priceFromText(text);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(delivery.value), cents);
          }
        }

        const proof = proofSelect?.selectedOptions[0];
        if (isPrinted() && proof?.dataset.addon) {
          const cents = priceFromText(proof.textContent);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(proof.textContent), cents);
          }
        }

        if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
          const folderOption = folderSelect.selectedOptions[0];
          const colorOption = folderColor.selectedOptions[0];
          const folderKey = folderOption?.dataset.folderKey;
          const cents = Number(colorOption?.dataset[folderKey + 'Price'] || 0);
          if (cents) {
            total += cents;
            addCostRow(
              folderOption.textContent.trim() + ' — ' + colorOption.textContent.trim(),
              cents
            );
          }
        }

        reviewTotal.textContent = formatMoney(total);
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_ged_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addonIds = collectAddons();
        if (!addonIds.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') {
            properties[name.slice(11, -1)] = value;
          }
        }

        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = {
          '_Added with': 'GED order',
          '_Parent product': root.dataset.productTitle
        };
        const items = [
          { id: variantId, quantity, properties },
          ...addonIds.map((id) => ({ id, quantity: 1, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = root.dataset.errorAdd;
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }

      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach(initializeGedForm);
    };

    const restoreDefaultDeliveries = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach((root) => {
        const selected = root.querySelector('input[name="sdd_ged_delivery"]:checked');
        if (selected) return;
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (!defaultDelivery) return;
        defaultDelivery.checked = true;
        defaultDelivery.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();

    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', restoreDefaultDeliveries);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-ged-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeGedForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';

      root.dataset.ready = 'true';

      const removeOldForm = () => {
        const oldForm = document.querySelector('#infiniteoptions-container');
        if (oldForm) oldForm.remove();
      };

      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'GedProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }

      root.querySelectorAll('input, textarea, select').forEach((control) => {
        control.setAttribute('form', productFormId);
      });

      const progress = root.querySelector('.sdd-ged-form__progress');
      const ready = root.querySelector('.sdd-ged-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };

      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);

      const priceFromText = (value) => {
        const match = String(value || '').match(/\+\s*\$([\d,]+(?:\.\d{1,2})?)/);
        return match ? Math.round(Number(match[1].replace(/,/g, '')) * 100) : 0;
      };

      const cleanCostLabel = (value) => String(value || '')
        .replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '')
        .trim();

      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };

      const addCostRow = (label, cents) => {
        addReviewRow(reviewCosts, label, formatMoney(cents));
      };

      const selectedDelivery = () => root.querySelector('input[name="sdd_ged_delivery"]:checked');
      const isPrinted = () => Boolean(selectedDelivery()?.dataset.addon);

      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const hasSelectedFolder = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !hasSelectedFolder;
        folderColor.disabled = !hasSelectedFolder;
        folderColor.required = hasSelectedFolder;
      };

      const updateConditionalFields = () => {
        const printed = isPrinted();
        if (deliveryProperty && selectedDelivery()) deliveryProperty.value = selectedDelivery().value;
        printUpgrades.hidden = !printed;
        if (proofSelect) proofSelect.disabled = !printed;
        if (folderSelect) folderSelect.disabled = !printed;
        digitalNote.hidden = printed;
        setFolderState();
      };

      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => {
          section.hidden = Number(section.dataset.step) !== number;
        });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          const active = index < number;
          indicator.classList.toggle('is-active', active);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };

      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => {
          field.setAttribute('aria-invalid', String(!field.checkValidity()));
        });
        if (invalid) {
          invalid.reportValidity();
          return false;
        }
        return true;
      };

      const folderAddonId = () => {
        if (!folderSelect || !folderColor || folderColor.disabled) return '';
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
        const colorOption = folderColor.selectedOptions[0];
        if (!folderKey || folderKey === 'none' || !colorOption) return '';
        const key = folderKey + 'Addon';
        return colorOption.dataset[key] || '';
      };

      const collectAddons = () => {
        const ids = [];
        const deliveryId = selectedDelivery()?.dataset.addon;
        const proofId = isPrinted() ? proofSelect?.selectedOptions[0]?.dataset.addon : '';
        const folderId = folderAddonId();
        [deliveryId, proofId, folderId].forEach((id) => {
          if (id) ids.push(Number(id));
        });
        return ids;
      };

      const calculateTotal = () => {
        const variant = currentVariant();
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          total += priceFromText(delivery.closest('label')?.textContent || delivery.value);
        }

        if (isPrinted()) {
          const proof = proofSelect?.selectedOptions[0];
          if (proof?.dataset.addon) total += priceFromText(proof.textContent);

          if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey;
            total += Number(folderColor.selectedOptions[0]?.dataset[folderKey + 'Price'] || 0);
          }
        }

        return total;
      };

      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };

      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();

        const variant = currentVariant();
        if (variant?.title && variant.title !== 'Default Title') {
          addReviewRow(reviewSelections, root.dataset.labelProductOption, variant.title);
        }

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;

          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;

          const value = control.tagName === 'SELECT'
            ? control.selectedOptions[0]?.textContent.trim()
            : String(control.value || '').trim();
          if (!value) return;

          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        let total = Number(variant?.price || 0) * quantity;
        addCostRow(root.dataset.productTitle, total);

        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) {
          const text = delivery.closest('label')?.textContent || delivery.value;
          const cents = priceFromText(text);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(delivery.value), cents);
          }
        }

        const proof = proofSelect?.selectedOptions[0];
        if (isPrinted() && proof?.dataset.addon) {
          const cents = priceFromText(proof.textContent);
          if (cents) {
            total += cents;
            addCostRow(cleanCostLabel(proof.textContent), cents);
          }
        }

        if (folderSelect && !folderSelect.disabled && folderColor && !folderColor.disabled) {
          const folderOption = folderSelect.selectedOptions[0];
          const colorOption = folderColor.selectedOptions[0];
          const folderKey = folderOption?.dataset.folderKey;
          const cents = Number(colorOption?.dataset[folderKey + 'Price'] || 0);
          if (cents) {
            total += cents;
            addCostRow(
              folderOption.textContent.trim() + ' — ' + colorOption.textContent.trim(),
              cents
            );
          }
        }

        reviewTotal.textContent = formatMoney(total);
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_ged_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addonIds = collectAddons();
        if (!addonIds.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') {
            properties[name.slice(11, -1)] = value;
          }
        }

        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = {
          '_Added with': 'GED order',
          '_Parent product': root.dataset.productTitle
        };
        const items = [
          { id: variantId, quantity, properties },
          ...addonIds.map((id) => ({ id, quantity: 1, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = root.dataset.errorAdd;
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }

      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach(initializeGedForm);
    };

    const restoreDefaultDeliveries = () => {
      document.querySelectorAll('[data-sdd-ged-form]').forEach((root) => {
        const selected = root.querySelector('input[name="sdd_ged_delivery"]:checked');
        if (selected) return;
        const defaultDelivery = root.querySelector('input[name="sdd_ged_delivery"]');
        if (!defaultDelivery) return;
        defaultDelivery.checked = true;
        defaultDelivery.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();

    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', restoreDefaultDeliveries);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-high-school-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && !syncNativeState()) {
          if (nativeStateError) nativeStateError.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-hs-copy-diploma-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && !syncNativeState()) {
          if (nativeStateError) nativeStateError.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-hs-diploma-transcript-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && !syncNativeState()) {
          if (nativeStateError) nativeStateError.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-hs-match-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return false;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      };
      const syncDeliveryFromCurrentVariant = () => {
        if (!hasNativeDelivery) return;
        const delivery = String(currentVariant()?.option1 || currentVariant()?.options?.[0] || '');
        const input = [...root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]')]
          .find((candidate) => String(candidate.dataset.optionValue || '') === delivery);
        if (input) input.checked = true;
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && (!syncNativeState() || !syncNativeVariant())) {
          if (nativeStateError) nativeStateError.hidden = false;
          errorBox.textContent = 'Please choose a valid delivery option.';
          errorBox.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState() || !syncNativeVariant()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          errorBox.textContent = 'Please choose a valid delivery option.';
          errorBox.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      syncDeliveryFromCurrentVariant();
      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-hs-transcripts-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHighSchoolForm = (root) => {
      if (!root || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'HighSchoolProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const isStateDelivery = root.dataset.isStateDelivery === 'true';
      const stateSelect = root.querySelector('[data-state-select]');
      const nativeStateProperty = root.querySelector('[data-native-state-property]');
      const nativeStateError = root.querySelector('[data-native-state-error]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-hs-form__progress');
      const ready = root.querySelector('.sdd-hs-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const syncNativeState = () => {
        if (!nativeStateProperty) return true;
        const variant = currentVariant();
        const state = String(variant?.option1 || variant?.options?.[0] || '').trim();
        const valid = state !== '' && !/^choose\s+your\s+state$/i.test(state);
        nativeStateProperty.value = valid ? state : '';
        if (nativeStateError && valid) nativeStateError.hidden = true;

        if (valid) {
          const mediaVariant = variant?.featured_media
            ? variant
            : variants.find((candidate) => {
                const candidateState = String(candidate?.option1 || candidate?.options?.[0] || '').trim();
                return candidateState === state && candidate?.featured_media;
              });
          const position = Number(mediaVariant?.featured_media?.position || mediaVariant?.featured_image?.position || 0);
          if (position > 0) {
            window.requestAnimationFrame(() => {
              const thumb = document.querySelector('[data-product-thumb][data-index="' + (position - 1) + '"]');
              if (thumb && !thumb.classList.contains('is-active')) thumb.click();
            });
          }
        }
        return valid;
      };
      const syncStateVariant = () => {
        if (!isStateDelivery || !stateSelect) return;
        const state = String(stateSelect.value || '');
        if (!state) return;
        const match = variants.find((variant) => {
          const optionOne = String(variant.option1 || variant.options?.[0] || '');
          const optionTwo = String(variant.option2 || variant.options?.[1] || '').toLowerCase();
          return optionOne === state && (optionTwo.includes('pdf') || optionTwo.includes('digital'));
        });
        const idField = productForm.querySelector('[name="id"]');
        if (match && idField) idField.value = String(match.id);
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_hs_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        return nativeVariants.find((variant) => String(variant.delivery || '') === delivery) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return false;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      };
      const syncDeliveryFromCurrentVariant = () => {
        if (!hasNativeDelivery) return;
        const delivery = String(currentVariant()?.option1 || currentVariant()?.options?.[0] || '');
        const input = [...root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]')]
          .find((candidate) => String(candidate.dataset.optionValue || '') === delivery);
        if (input) input.checked = true;
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mailed');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_hs_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = (usesFormDelivery || hasNativeDelivery)
          ? (selectedDelivery()?.value || 'Digital PDF Download Only')
          : (currentVariant()?.title || 'Selected above');
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const active = isPrinted() && folderSelect.selectedOptions[0]?.dataset.folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select').forEach((select) => { select.disabled = !printed; });
        digitalNote.hidden = printed;
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (step === 1 && (!syncNativeState() || !syncNativeVariant())) {
          if (nativeStateError) nativeStateError.hidden = false;
          errorBox.textContent = 'Please choose a valid delivery option.';
          errorBox.hidden = false;
          return false;
        }
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        if (usesFormDelivery) {
          const delivery = selectedDelivery();
          if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        }
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach((select) => {
            const option = select.selectedOptions[0];
            if (!option?.dataset.addon) return;
            const quantity = Number(option.dataset.addonQuantity || 1);
            entries.push({
              id: Number(option.dataset.addon),
              quantity,
              price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
              label: cleanLabel(option.textContent)
            });
          });
          if (folderColor && !folderColor.disabled) {
            const option = folderColor.selectedOptions[0];
            if (option?.dataset.addon) entries.push({ id: Number(option.dataset.addon), quantity: 1, price: optionPrice(option), label: 'Diploma folder — ' + cleanLabel(option.textContent) });
          }
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (!hasNativeDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-state-select]')) syncStateVariant();
        if (event.target.matches('input[name="sdd_hs_delivery"]')) updateConditionalFields();
        if (event.target.matches('[data-folder-select]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        syncNativeState();
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);
      document.querySelectorAll('.variant-wrapper select, .variant-input-wrap input').forEach((control) => {
        control.addEventListener('change', () => {
          window.setTimeout(() => {
            syncNativeState();
            updateConditionalFields();
            updateLiveTotal();
            if (!ready.hidden) renderReview();
          }, 0);
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!syncNativeState() || !syncNativeVariant()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (nativeStateError) nativeStateError.hidden = false;
          errorBox.textContent = 'Please choose a valid delivery option.';
          errorBox.hidden = false;
          ready.hidden = true;
          progress.hidden = false;
          show(1);
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'High School order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      syncDeliveryFromCurrentVariant();
      if ((usesFormDelivery || hasNativeDelivery) && !selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_hs_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      syncStateVariant();
      syncNativeState();
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-hs-form]').forEach(initializeHighSchoolForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-international-australia-transcript-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-international-native-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-africa-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-africa-match-transcript"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-albania-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-any-country-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-any-country-match-transcript"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-argentina-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-australia-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-brazil-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-canada-match-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-canada-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-canada-match-transcript"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-canada-red-seal"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-columbia-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-germany-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-india-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-ireland-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-italy-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-malaysia-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-mexico-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-new-zealand-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-panama-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-philippines-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-philippines-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-puerto-rico-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-singapore-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-spain-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-stock-transcript"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-turkey-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-uae-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-uk-certificate"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-uk-match-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-uk-match-diploma"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sdd-intl-uk-match-transcript"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCollegeForm = (root) => {
      if (!root || root.dataset.sddFormFamily !== 'international' || root.dataset.ready === 'true') return;

      const productForm = root.closest('.product-single__meta')?.querySelector('.product-single__form')
        || document.querySelector('.product-single__form');
      if (!productForm) return;
      productForm.dataset.sddLocalCartHandler = 'true';
      root.dataset.ready = 'true';

      const removeOldForm = () => document.querySelectorAll('#infiniteoptions-container').forEach((form) => form.remove());
      removeOldForm();
      new MutationObserver(removeOldForm).observe(document.body, { childList: true, subtree: true });

      let productFormId = productForm.getAttribute('id');
      if (!productFormId) {
        productFormId = 'CollegeProductForm-' + Date.now();
        productForm.setAttribute('id', productFormId);
      }
      root.querySelectorAll('input, textarea, select').forEach((control) => control.setAttribute('form', productFormId));

      const usesFormDelivery = root.dataset.usesFormDelivery === 'true';
      const hasNativeDelivery = root.dataset.hasNativeDelivery === 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const nativeVariants = JSON.parse(root.querySelector('[data-native-variant-map]')?.textContent || '[]');
      const progress = root.querySelector('.sdd-college-form__progress');
      const ready = root.querySelector('.sdd-college-form__ready');
      const errorBox = root.querySelector('[data-form-error]');
      const deliveryProperty = root.querySelector('[data-delivery-property]');
      const printUpgrades = root.querySelector('[data-print-upgrades]');
      const digitalNote = root.querySelector('[data-digital-note]');
      const diplomaSize = root.querySelector('[data-diploma-size]');
      const customSizeField = root.querySelector('[data-custom-size-field]');
      const proofSelect = root.querySelector('[data-proof-select]');
      const proofContactField = root.querySelector('[data-proof-contact-field]');
      const folderSelect = root.querySelector('[data-folder-select]');
      const folderColorField = root.querySelector('[data-folder-color-field]');
      const folderColor = root.querySelector('[data-folder-color]');
      const folderCustomField = root.querySelector('[data-folder-custom-field]');
      const folderCustomSelect = root.querySelector('[data-folder-custom-select]');
      const folderNameField = root.querySelector('[data-folder-name-field]');
      const folderNameSelect = root.querySelector('[data-folder-name-select]');
      const reviewSelections = root.querySelector('[data-review-selections]');
      const reviewCosts = root.querySelector('[data-review-costs]');
      const reviewTotal = root.querySelector('[data-review-total]');
      const liveTotals = root.querySelectorAll('[data-live-total]');
      const pageChoice = root.querySelector('[data-page-choice]');
      let step = 1;

      const currentVariant = () => {
        const id = String(productForm.querySelector('[name="id"]')?.value || '');
        return variants.find((variant) => String(variant.id) === id) || variants[0];
      };
      const selectedDelivery = () => root.querySelector('input[name="sdd_college_delivery"]:checked');
      const selectedNativeVariant = (deliveryInput = selectedDelivery()) => {
        if (!hasNativeDelivery || !deliveryInput) return null;
        const delivery = String(deliveryInput.dataset.optionValue || '');
        const pages = String(pageChoice?.value || '');
        return nativeVariants.find((variant) => (
          String(variant.delivery || '') === delivery
          && (!pages || String(variant.pages || '') === pages)
        )) || null;
      };
      const syncNativeVariant = () => {
        const match = selectedNativeVariant();
        const idInput = productForm.querySelector('[name="id"]');
        if (!match || !idInput) return;
        if (String(idInput.value) !== String(match.id)) {
          idInput.value = String(match.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const isPrinted = () => {
        const kind = String(selectedDelivery()?.dataset.deliveryKind || '');
        if (kind) return kind === 'printed' || kind === 'both';
        const title = String(currentVariant()?.title || '').toLowerCase();
        return title.includes('printed') || title.includes('mail') || title.includes('hardcopy');
      };
      const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(Number(cents || 0) / 100);
      const cleanLabel = (value) => String(value || '').replace(/\s*\(?\+\s*\$[\d,]+(?:\.\d{1,2})?\)?/g, '').trim();
      const optionPrice = (option) => Number(option?.dataset.addonPrice || 0);

      const updateDeliveryPrices = () => {
        if (!hasNativeDelivery) return;
        root.querySelectorAll('input[name="sdd_college_delivery"][data-option-value]').forEach((input) => {
          const price = input.closest('label')?.querySelector('[data-delivery-price]');
          const match = selectedNativeVariant(input);
          if (price) price.textContent = match ? formatMoney(match.price) : '';
        });
      };
      const updatePagePrices = () => {
        if (!hasNativeDelivery || !pageChoice) return;
        const delivery = String(selectedDelivery()?.dataset.optionValue || '');
        Array.from(pageChoice.options).forEach((option) => {
          const pages = String(option.dataset.optionValue || option.value || '');
          const label = String(option.dataset.baseLabel || pages);
          const match = nativeVariants.find((variant) => (
            String(variant.delivery || '') === delivery
            && String(variant.pages || '') === pages
          ));
          option.textContent = match ? label + ' — ' + formatMoney(match.price) : label;
        });
      };
      const syncDeliveryProperty = () => {
        if (!deliveryProperty) return;
        deliveryProperty.value = selectedDelivery()?.value || 'Digital PDF Download Only';
      };
      const setDiplomaSizeState = () => {
        if (!diplomaSize || !customSizeField) return;
        const input = customSizeField.querySelector('input');
        const active = diplomaSize.value === 'Custom size';
        customSizeField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setProofState = () => {
        if (!proofSelect || !proofContactField) return;
        const input = proofContactField.querySelector('input');
        const active = isPrinted() && Boolean(proofSelect.selectedOptions[0]?.dataset.addon);
        proofContactField.hidden = !active;
        input.disabled = !active;
        input.required = active;
      };
      const setFolderState = () => {
        if (!folderSelect || !folderColorField || !folderColor) return;
        const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
        const active = isPrinted() && folderKey !== 'none';
        folderColorField.hidden = !active;
        folderColor.disabled = !active;
        folderColor.required = active;
        if (folderCustomField && folderCustomSelect) {
          const customActive = active && folderKey === 'custom';
          folderCustomField.hidden = !customActive;
          folderCustomSelect.disabled = !customActive;
        }
        if (folderNameField && folderNameSelect) {
          folderNameField.hidden = !active;
          folderNameSelect.disabled = !active;
        }
      };
      const updateConditionalFields = () => {
        syncNativeVariant();
        updateDeliveryPrices();
        updatePagePrices();
        const printed = isPrinted();
        syncDeliveryProperty();
        printUpgrades.hidden = !printed;
        printUpgrades.querySelectorAll('select, input, textarea').forEach((control) => { control.disabled = !printed; });
        digitalNote.hidden = printed;
        setDiplomaSizeState();
        setProofState();
        setFolderState();
      };
      const scrollToFormTop = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const header = document.querySelector('.site-header--stuck, .site-header');
            const headerPosition = header ? window.getComputedStyle(header).position : '';
            const headerOffset = header && (headerPosition === 'fixed' || headerPosition === 'sticky')
              ? header.getBoundingClientRect().height
              : 0;
            const top = root.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: 'instant'
            });
          });
        });
      };

      const show = (number) => {
        step = number;
        root.querySelectorAll('[data-step]').forEach((section) => { section.hidden = Number(section.dataset.step) !== number; });
        progress.querySelectorAll('span').forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index < number);
          if (index === number - 1) indicator.setAttribute('aria-current', 'step');
          else indicator.removeAttribute('aria-current');
        });
      };
      const validateStep = () => {
        const section = root.querySelector('[data-step="' + step + '"]');
        const requiredFields = [...section.querySelectorAll('[required]:not(:disabled)')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        requiredFields.forEach((field) => field.setAttribute('aria-invalid', String(!field.checkValidity())));
        if (!invalid) return true;
        invalid.reportValidity();
        return false;
      };

      const selectedAddonEntries = () => {
        const entries = [];
        const addSelectedOption = (select) => {
          const option = select?.selectedOptions[0];
          if (!option?.dataset.addon) return;
          const quantity = Number(option.dataset.addonQuantity || 1);
          entries.push({
            id: Number(option.dataset.addon),
            quantity,
            price: option.dataset.unitPrice ? Number(option.dataset.unitPrice) * quantity : optionPrice(option),
            label: cleanLabel(option.textContent)
          });
        };
        const delivery = selectedDelivery();
        if (delivery?.dataset.addon) entries.push({ id: Number(delivery.dataset.addon), quantity: 1, price: optionPrice(delivery), label: cleanLabel(delivery.value) });
        root.querySelectorAll('[data-always-addon-select]:not(:disabled)').forEach(addSelectedOption);
        if (isPrinted()) {
          root.querySelectorAll('[data-addon-select]:not(:disabled)').forEach(addSelectedOption);
          if (folderSelect && folderColor && !folderColor.disabled) {
            const folderKey = folderSelect.selectedOptions[0]?.dataset.folderKey || 'none';
            const colorOption = folderColor.selectedOptions[0];
            const id = colorOption?.getAttribute('data-' + folderKey + '-addon');
            const price = Number(colorOption?.getAttribute('data-' + folderKey + '-price') || 0);
            if (id) entries.push({
              id: Number(id),
              quantity: 1,
              price,
              label: cleanLabel(folderSelect.selectedOptions[0]?.textContent) + ' — ' + cleanLabel(colorOption.textContent)
            });
          }
          if (folderCustomSelect && !folderCustomSelect.disabled) addSelectedOption(folderCustomSelect);
          if (folderNameSelect && !folderNameSelect.disabled) addSelectedOption(folderNameSelect);
        }
        return entries;
      };
      const calculateTotal = () => {
        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        return (Number(currentVariant()?.price || 0) * quantity)
          + selectedAddonEntries().reduce((sum, entry) => sum + entry.price, 0);
      };
      const updateLiveTotal = () => {
        const amount = formatMoney(calculateTotal());
        liveTotals.forEach((element) => { element.textContent = amount; });
      };
      const addReviewRow = (list, label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      };
      const renderReview = () => {
        reviewSelections.replaceChildren();
        reviewCosts.replaceChildren();
        const variant = currentVariant();
        if (usesFormDelivery && variant?.title && variant.title !== 'Default Title') addReviewRow(reviewSelections, 'Product option', variant.title);

        const seen = new Set();
        root.querySelectorAll('[name^="properties["]').forEach((control) => {
          if (control.disabled || control.hasAttribute('data-review-skip')) return;
          if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
          const label = control.name.slice(11, -1).replace(/:$/, '').trim();
          if (!label || seen.has(label)) return;
          const value = control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : String(control.value || '').trim();
          if (!value) return;
          seen.add(label);
          addReviewRow(reviewSelections, label, value);
        });

        const quantity = Number(productForm.querySelector('[name="quantity"]')?.value || 1);
        const base = Number(variant?.price || 0) * quantity;
        addReviewRow(reviewCosts, root.dataset.productTitle + (quantity > 1 ? ' × ' + quantity : ''), formatMoney(base));
        selectedAddonEntries().forEach((entry) => addReviewRow(reviewCosts, entry.label, formatMoney(entry.price)));
        reviewTotal.textContent = formatMoney(calculateTotal());
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="sdd_college_delivery"], [data-page-choice]')) updateConditionalFields();
        if (event.target.matches('[data-diploma-size]')) setDiplomaSizeState();
        if (event.target.matches('[data-proof-select]')) setProofState();
        if (event.target.matches('[data-folder-select], [data-folder-color]')) setFolderState();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('change', () => {
        updateConditionalFields();
        updateLiveTotal();
        if (!ready.hidden) renderReview();
      });
      productForm.addEventListener('input', updateLiveTotal);

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-next]') && validateStep()) {
          show(step + 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-back]')) {
          show(step - 1);
          scrollToFormTop();
        }
        if (event.target.closest('[data-edit]')) {
          ready.hidden = true;
          progress.hidden = false;
          show(1);
        }
        if (event.target.closest('[data-finish]') && validateStep()) {
          renderReview();
          root.querySelector('[data-step="3"]').hidden = true;
          progress.hidden = true;
          ready.hidden = false;
          scrollToFormTop();
        }
      });

      productForm.addEventListener('submit', async (event) => {
        if (productForm.dataset.sddSubmitting === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const invalid = [...root.querySelectorAll('[required]:not(:disabled)')].find((field) => !field.checkValidity());
        if (invalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalidStep = invalid.closest('[data-step]');
          ready.hidden = true;
          progress.hidden = false;
          if (invalidStep) show(Number(invalidStep.dataset.step));
          invalid.reportValidity();
          return;
        }

        const addons = selectedAddonEntries();
        if (!addons.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        productForm.dataset.sddSubmitting = 'true';
        const submit = productForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        errorBox.hidden = true;

        const formData = new FormData(productForm);
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (name.startsWith('properties[') && name.endsWith(']') && value !== '') properties[name.slice(11, -1)] = value;
        }
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonProperties = { '_Added with': 'International order', '_Parent product': root.dataset.productTitle };
        const items = [
          { id: variantId, quantity, properties },
          ...addons.map((entry) => ({ id: entry.id, quantity: entry.quantity, properties: addonProperties }))
        ];

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          delete productForm.dataset.sddSubmitting;
          if (submit) submit.disabled = false;
          errorBox.textContent = 'We could not add this order to the cart. Please try again.';
          errorBox.hidden = false;
        }
      }, true);

      if (!selectedDelivery()) {
        const defaultDelivery = root.querySelector('input[name="sdd_college_delivery"]');
        if (defaultDelivery) defaultDelivery.checked = true;
      }
      updateConditionalFields();
      updateLiveTotal();
      show(1);
    };

    const initializeAll = () => document.querySelectorAll('[data-sdd-college-form]').forEach(initializeCollegeForm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    window.addEventListener('pageshow', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
